"use client";

import { useEffect } from "react";
import { useImmer } from "use-immer";
import { useSearchParams } from "next/navigation";
import { MultiSelectFilter } from "@/forms/filters/multi-select-filter/multi-select-filter";
import { TextFilter } from "@/forms/filters/text-filter/text-filter";
import { createFilterModel } from "./model";
import { MEDICAL_CHAMBER_COOKIE } from "./medical-chamber-cookie";

const ONE_YEAR_S = 365 * 24 * 60 * 60;

function storeChambers(values: string[]) {
  document.cookie =
    values.length > 0
      ? `${MEDICAL_CHAMBER_COOKIE}=${encodeURIComponent(
          values.join(","),
        )}; path=/; max-age=${ONE_YEAR_S}`
      : `${MEDICAL_CHAMBER_COOKIE}=; path=/; max-age=0`;
}

export const Filters = ({
  filtersSource = { medicalChamber: {}, province: {} },
}: {
  filtersSource: InternshipMapFilterSource;
}) => {
  const searchParams = useSearchParams();
  const [filters, setFilters] = useImmer(
    createFilterModel(filtersSource, searchParams),
  );

  useEffect(() => {
    const newFilters = createFilterModel(filtersSource, searchParams);
    setFilters(newFilters);
  }, [searchParams, filtersSource]);

  return (
    <div className={"@512:grid-cols-3 @512:gap-3 grid grid-cols-1 gap-2"}>
      <MultiSelectFilter
        filter={filters.medicalChamber}
        faintIcons={true}
        onChange={(selected) =>
          storeChambers(selected.map((option) => String(option.value)))
        }
      />
      <MultiSelectFilter filter={filters.province} faintIcons={true} />
      <TextFilter filter={filters.q} />
    </div>
  );
};
